const sidebar: Record<string, string> = {
    scrollToError: 'Перейти к ошибк{count, plural, one {e} other {ам}}',
};

export default sidebar;
